<template>
  <div class="slide-container">

    <div class="title-with-selector h3-selector">
      <h3 class="subtitle"><b>{{'Slide ' + slide.order}}</b></h3>
      <state-selector :selected="slide ? parseInt(slide.state_id) : null" 
                      :target="slide"
                      :update="'slide'" 
      ></state-selector>
    </div>

    <div class="columns is-multiline">
      <div class="column is-6">
        <b>Descrição [PT]</b><br/>
        <div v-html="htmlText.pt.description"></div>
        <div class="placeholder-slide-text" v-if="!htmlText.pt.description">não definido</div>
      </div>
      <div class="column is-6" v-if="showPlusDetail">
        <b>Mais Detalhes [PT]</b><br/>
        <div v-html="htmlText.pt.plus_detail"></div>
        <div class="placeholder-slide-text" v-if="!htmlText.pt.plus_detail">não definido</div>
      </div>

      <div class="column is-6">
        <b>Descrição [EN]</b><br/>
        <div v-html="htmlText.en.description"></div>
        <div class="placeholder-slide-text" v-if="!htmlText.en.description">não definido</div>
      </div>
      <div class="column is-6" v-if="showPlusDetail">
        <b>Mais Detalhes [EN]</b><br/>
        <div v-html="htmlText.en.plus_detail"></div>
        <div class="placeholder-slide-text" v-if="!htmlText.en.plus_detail">não definido</div>
      </div>

      <div class="column is-6">
        <b>Descrição [ES]</b><br/>
        <div v-html="htmlText.es.description"></div>
        <div class="placeholder-slide-text" v-if="!htmlText.es.description">não definido</div>
      </div>
      <div class="column is-6" v-if="showPlusDetail">
        <b>Mais Detalhes [ES]</b><br/>
        <div v-html="htmlText.es.plus_detail"></div>
        <div class="placeholder-slide-text" v-if="!htmlText.es.plus_detail">não definido</div>
      </div>

      <div class="column is-6">
        <b>Descrição [FR]</b><br/>
        <div v-html="htmlText.fr.description"></div>
        <div class="placeholder-slide-text" v-if="!htmlText.fr.description">não definido</div>
      </div>
      <div class="column is-6" v-if="showPlusDetail">
        <b>Mais Detalhes [FR]</b><br/>
        <div v-html="htmlText.fr.plus_detail"></div>
        <div class="placeholder-slide-text" v-if="!htmlText.fr.plus_detail">não definido</div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-6" v-if="slide.foreground_path_1">
        <span><b>Foreground 1</b></span>

        <figure v-if="isVideo(slide.foreground_path_1)" class="image">
          <video width="100%" height="100%" controls :id="`video-${slide.id}`">
            <source :src="slideImagePath + slide.foreground_path_1" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </figure>

        <figure class="image coach-image" v-else>
          <img :src="slideImagePath + slide.foreground_path_1">
        </figure>
      </div>

      <div class="column is-6" v-if="slide.foreground_path_2 && !isVideo(slide.foreground_path_1)">
        <span><b>Foreground 2</b></span>
        <figure class="image coach-image">
          <img :src="slideImagePath + slide.foreground_path_2">
        </figure>
      </div>
    </div>

    <p class="control has-addons">
      <b class="inline-lable">Posição:</b>
      <a class="button is-small"
         :class="{'is-disabled' : slide.order == 1}"
         @click="reorderSlides(1)"
      >
        <span class="icon is-small">
          <i class="fa fa-angle-double-up"></i>
        </span>
        <span>Topo</span>
      </a>
      <a class="button is-small"
         :class="{'is-disabled' : slide.order == 1}"
         @click="reorderSlides(parseInt(slide.order) - 1)"
      >
        <span class="icon is-small">
          <i class="fa fa-angle-up"></i>
        </span>
        <span>-1</span>
      </a>
      <a class="button is-small"
         :class="{'is-disabled' : slide.order == slideTotal}"
         @click="reorderSlides(parseInt(slide.order) + 1)"
      >
        <span class="icon is-small">
          <i class="fa fa-angle-down"></i>
        </span>
        <span>+1</span>
      </a>
      <a class="button is-small"
         :class="{'is-disabled' : slide.order == slideTotal}"
         @click="reorderSlides(slideTotal)"
      >
        <span class="icon is-small">
          <i class="fa fa-angle-double-down"></i>
        </span>
        <span>Fundo</span>
      </a>
    </p>

    <a class="button is-small is-info" v-if="!slide.sub_menu && !slide.parent_id && showSubMenu" @click="openSlideSetEditModal">
      <span class="icon is-small">
        <i class="fa fa-check-square-o"></i>
      </span>
      <span>Adicionar Sub-slides</span>
    </a>
    <a class="button is-small is-danger" v-if="slide.sub_menu" @click="openSlideSetDeleteModal">
      <span class="icon is-small">
        <i class="fa fa-trash"></i>
      </span>
      <span>Apagar Sub-slides</span>
    </a>
    <a class="button is-small is-info" v-if="slide.sub_menu" @click="goToSubSlide">
      <span class="icon is-small">
        <i class="fa fa-external-link"></i>
      </span>
      <span>Sub-slides</span>
    </a>
    <a class="button is-small is-primary" @click="openSlideEditModal">
      <span class="icon is-small">
        <i class="fa fa-edit"></i>
      </span>
      <span>Editar</span>
    </a>
    <a class="button is-small is-danger" @click="openSlideDeleteModal">
      <span class="icon is-small">
        <i class="fa fa-trash"></i>
      </span>
      <span>Apagar</span>
    </a>
    <hr>
  </div>
</template>

<script>
  import Vue from 'vue'
  import SlideEditModal from './SlideEditModal'
  import SlideDeleteModal from './SlideDeleteModal'
  import SlideSetEditModal from './SlideSetEditModal'
  import SlideSetDeleteModal from './SlideSetDeleteModal'
  import StateSelector from '../Util/StateSelector'
  import { SLIDE_IMG_PATH, MENUS } from '../../config'

  const SlideEditModalComponent = Vue.extend(SlideEditModal)
  const SlideDeleteModalComponent = Vue.extend(SlideDeleteModal)
  const SlideSetEditModalComponent = Vue.extend(SlideSetEditModal)
  const SlideSetDeleteModalComponent = Vue.extend(SlideSetDeleteModal)

  export default {
    components: {
      StateSelector
    },

    props: {
      slide: Object,
      slideTotal: Number,
      parent: Number,
      menu: Object
    },

    data () {
      return {
        coachId: this.$store.state.route.params.id,
        categoryId: this.$store.state.route.params.cat,
        slideImagePath: SLIDE_IMG_PATH,
        mounted: false
      }
    },

    mounted () {
      this.mounted = true
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      },

      showPlusDetail () {
        let category = parseInt(this.slide.slide_category_id)
        let parentCategory = parseInt(this.menu.parent_id)
        if (category === MENUS.ambepoca ||
            parentCategory === MENUS.ambepoca ||
            category === MENUS.eraumavez ||
            parentCategory === MENUS.eraumavez
        ) {
          return false
        }
        return true
      },

      showSubMenu () {
        let category = parseInt(this.slide.slide_category_id)
        let parentCategory = parseInt(this.menu.parent_id)
        if (category === MENUS.eraumavez ||
            parentCategory === MENUS.eraumavez
        ) {
          return false
        }
        return true
      },

      slideState () {
        let stateId = this.slide.state_id
        let text = null
        let color = null

        switch (parseInt(stateId)) {
          case 1:
            text = 'Rascunho'
            color = 'is-danger'
            break
          case 2:
            text = 'Pendente'
            color = 'is-warning'
            break
          case 3:
            text = 'Publicado'
            color = 'is-success'
            break
          case 4:
            text = 'Apagado'
            color = 'is-dark'
            break
          default:
            text = 'Estado desconhecido'
            color = 'is-info'
        }

        return {text: text, color: color}
      },

      htmlText () {
        if (this.mounted) {
          return {
            pt: {
              description: this.slide.languages[0].pivot.description ? this.deltaToHtml(this.slide.languages[0].pivot.description) : null,
              plus_detail: this.slide.languages[0].pivot.plus_detail ? this.deltaToHtml(this.slide.languages[0].pivot.plus_detail) : null
            },
            en: {
              description: this.slide.languages[1].pivot.description ? this.deltaToHtml(this.slide.languages[1].pivot.description) : null,
              plus_detail: this.slide.languages[1].pivot.plus_detail ? this.deltaToHtml(this.slide.languages[1].pivot.plus_detail) : null
            },
            es: {
              description: this.slide.languages[2].pivot.description ? this.deltaToHtml(this.slide.languages[2].pivot.description) : null,
              plus_detail: this.slide.languages[2].pivot.plus_detail ? this.deltaToHtml(this.slide.languages[2].pivot.plus_detail) : null
            },
            fr: {
              description: this.slide.languages[3].pivot.description ? this.deltaToHtml(this.slide.languages[3].pivot.description) : null,
              plus_detail: this.slide.languages[3].pivot.plus_detail ? this.deltaToHtml(this.slide.languages[3].pivot.plus_detail) : null
            }
          }
        } else {
          return {
            pt: {
              description: null,
              plus_detail: null
            },
            en: {
              description: null,
              plus_detail: null
            },
            es: {
              description: null,
              plus_detail: null
            },
            fr: {
              description: null,
              plus_detail: null
            }
          }
        }
      }
    },

    methods: {
      deltasToHtml () {
        for (let language of this.slide.languages) {
          let description = language.pivot.description ? this.deltaToHtml(language.pivot.description) : null
          let plusDetail = language.pivot.plus_detail ? this.deltaToHtml(language.pivot.plus_detail) : null

          this.htmlText[language.slug].description = description
          this.htmlText[language.slug].plus_detail = plusDetail
        }
      },

      deltaToHtml (delta) {
        let html = ''
        for (let section of delta.ops) {
          if (section.attributes) {
            if (section.attributes.bold) {
              html += '<b>'
            }
            if (section.attributes.italic) {
              html += '<i>'
            }
            if (section.attributes.script && section.attributes.script === 'super') {
              html += '<sup>'
            }

            html += section.insert

            if (section.attributes.bold) {
              html += '</b>'
            }
            if (section.attributes.italic) {
              html += '</i>'
            }
            if (section.attributes.script && section.attributes.script === 'super') {
              html += '</sup>'
            }
          } else {
            html += section.insert
          }
        }
        return html
      },

      reorderSlides (newPosition) {
        this.$store.dispatch('reorderSlides', {slide: this.slide, position: newPosition})
      },

      openSlideEditModal () {
        let openCardModal = (propsData = {}) => {
          return new SlideEditModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        let data = {
          title: 'Editar Slide',
          slideTotal: this.slideTotal,
          slideData: this.slide,
          parent: null,
          menu: this.menu,
          isSubslide: false
        }

        if (this.parent) {
          data = {
            title: 'Editar Sub-slide',
            slideTotal: this.slideTotal,
            slideData: this.slide,
            parent: this.parent,
            menu: this.menu,
            isSubslide: true
          }
        }

        openCardModal(data)
      },

      openSlideDeleteModal () {
        let openCardModal = (propsData = {}) => {
          return new SlideDeleteModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        let data = {
          title: 'Apagar Slide',
          id: parseInt(this.slide.id),
          is_sub: false
        }

        if (this.parent) {
          data = {
            title: 'Apagar Sub-slide',
            id: parseInt(this.slide.id),
            is_sub: true
          }
        }

        openCardModal(data)
      },

      openSlideSetEditModal () {
        let openCardModal = (propsData = {}) => {
          return new SlideSetEditModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Definir Características dos Sub-Slides',
          coach_id: parseInt(this.coachId),
          menu_id: parseInt(this.categoryId),
          parent_slide_id: parseInt(this.slide.id),
          categoryData: null
        })
      },

      openSlideSetDeleteModal () {
        let openCardModal = (propsData = {}) => {
          return new SlideSetDeleteModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Apagar Sub-slides',
          coach_id: parseInt(this.coachId),
          menu_id: parseInt(this.categoryId),
          id: parseInt(this.slide.sub_menu)
        })
      },

      goToSubSlide () {
        window.router.push({path: `/${this.coachId}/submenu/${this.slide.sub_menu}`})
      },

      isVideo (path) {
        let videoExtensions = ['mp4', 'mov', 'mkv', 'avi']

        let splitPath = path.split('.')
        let extension = splitPath.pop()

        if (videoExtensions.includes(extension)) {
          return true
        }
        return false
      }
    },

    watch: {
      currentEvent: function (val) {
      },

      slide: function (val) {
        if (this.isVideo(val.foreground_path_1)) {
          let video = document.getElementById('video-' + this.slide.id)
          if (video) {
            video.load(this.slideImagePath + val)
          }
        }
      }
    }
  }
</script>

<style lang="scss">
.inline-lable {
  margin-right: 8px;
}

.placeholder-slide-text {
  color: rgba(0, 0, 0, 0.3);
}
</style>


// WEBPACK FOOTER //
// LevelSlide.vue?a35ec310